export { default } from './ChunkLoadingPopover';
